export default __webpack_public_path__ + "static/media/jeffrey-dahmer.b83a016c.jpg";